module.exports = __webpack_public_path__ + "static/img/sy_5.a322b65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coretesc/sy_5.png
// module id = a1aD
// module chunks = 1